export const Language = {
  ENGLISH: 'EN',
  FRENCH: 'FR'
} as const;

export const Culture = {
  ENGLISH: 'en-CA',
  FRENCH: 'fr-CA'
} as const;
